__turbopack_context__.v({
  "closeBtn": "GalleryModal-module__nC6jEG__closeBtn",
  "content": "GalleryModal-module__nC6jEG__content",
  "divider": "GalleryModal-module__nC6jEG__divider",
  "empty": "GalleryModal-module__nC6jEG__empty",
  "header": "GalleryModal-module__nC6jEG__header",
  "modal": "GalleryModal-module__nC6jEG__modal",
  "overlay": "GalleryModal-module__nC6jEG__overlay",
  "previewImg": "GalleryModal-module__nC6jEG__previewImg",
  "previewWrap": "GalleryModal-module__nC6jEG__previewWrap",
  "root": "GalleryModal-module__nC6jEG__root",
  "tab": "GalleryModal-module__nC6jEG__tab",
  "tabActive": "GalleryModal-module__nC6jEG__tabActive",
  "tabs": "GalleryModal-module__nC6jEG__tabs",
  "thumbBtn": "GalleryModal-module__nC6jEG__thumbBtn",
  "thumbBtnActive": "GalleryModal-module__nC6jEG__thumbBtnActive",
  "thumbsGrid": "GalleryModal-module__nC6jEG__thumbsGrid",
  "thumbsWrap": "GalleryModal-module__nC6jEG__thumbsWrap",
  "title": "GalleryModal-module__nC6jEG__title",
});
